import { TableContainer, TextField, Paper } from "@mui/material";
import * as React from "react";
import styled from "styled-components";
import { convertToRuFormat } from "../../../utilits/helpers/convertDateFormat";

export default function Contragent({ item }) {

  return (
    <TableContainer
      component={Paper}
      style={{ height: "270px", padding: "0 10px" }}
    >
      <StyledNameBlock>
        <StyledNameTextField
          id="outlined-basic"
          label="Фамилия"
          variant="outlined"
          size="small"
          value={item.attributes.surname}
        />
        <StyledNameTextField
          id="outlined-basic"
          label="Имя"
          variant="outlined"
          size="small"
          value={item.attributes.name}
        />
        <StyledNameTextField
          id="outlined-basic"
          label="Отчество"
          variant="outlined"
          size="small"
          value={item.attributes.lastname}
        />
      </StyledNameBlock>
      <BlockStyled
        margin="10px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStyled
          id="outlined-basic"
          label="Дата рождения"
          variant="outlined"
          value={item.attributes.birthday ? convertToRuFormat(item.attributes.birthday) : ""}
          width="18%"
        />
        <TextFieldStyled
          id="outlined-basic"
          label="Паспортные данные"
          variant="outlined"
          value={item.attributes.passport}
          width="80%"
        />
      </BlockStyled>
      <StyledFirstBlock>
        <StyledAddressTextField
          id="outlined-basic"
          label="Адрес"
          variant="outlined"
          value={item.attributes.address}
        />
        <StyledSmallTextFields
          id="outlined-basic"
          label="ИНН"
          variant="outlined"
          value={item.attributes.inn}
        />
        <StyledSmallTextFields
          id="outlined-basic"
          label="Телефон"
          variant="outlined"
          value={item.attributes.phone}
        />
      </StyledFirstBlock>
    </TableContainer>
  );
}

const BlockStyled = styled.div`
  width: ${(props) => props.width};
  display: ${(props) => props.display};
  justify-content: ${(props) => props.justifyContent};
  flex-direction: ${(props) => props.flexDirection};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  align-items: ${(props) => props.alignItems};
`;

const TextFieldStyled = styled(TextField)`
  width: ${(props) => props.width};
  margin: ${(props) => props.mrg};
`;

const StyledNameBlock = styled.div`
  margin-bottom: 20px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
`;

const StyledNameTextField = styled(TextField)`
  width: 33%;
`;

const StyledFirstBlock = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
`;

const StyledAddressTextField = styled(TextField)`
  width: 50%;
`;

const StyledSmallTextFields = styled(TextField)`
  width: 23%;
  margin: ${(props) => props.mrg};
  padding: 0 5px;
`;
